export default {
  name: 'Inicio',
  path: '/',
  component: () => import('./dashboard-page.vue')
};
